// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WhatsappMessageTemplates_SalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/whatsapp_message_templates/salvar.
 *
 * Returns the persisted template_id (auto-increment for inserts, echoed for
 * updates). Frontend uses this id to refresh related UI state.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface WhatsappMessageTemplates_SalvarResponseDados {
template_id: number
}

export type WhatsappMessageTemplates_SalvarResponse = ApiResponse<WhatsappMessageTemplates_SalvarResponseDados>;

registerResponseContract('WhatsappMessageTemplates_SalvarResponse', {
  template_id: { type: 'number',  required: true },
})
